module.exports = __webpack_public_path__ + "img/DSC04034.08f66131.jpg";